module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "output_options-modal",
    attrs: {
      "width": "460px",
      "height": "130px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [(_vm.textTitle && _vm.textTitle.length > 0) ? _c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.textTitle) + " ")])])], 1)]) : _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body output_options-modal-body",
    staticStyle: {
      "height": "150px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.messageLabel)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.inputPrefix)
    }
  }), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "width": "80px",
      "display": "inline"
    },
    attrs: {
      "type": "number",
      "min": _vm.minVal,
      "id": "local_value",
      "name": "local_value",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "keyup": function($event) {
        _vm.keyUp($event.target.id, $event.target.value, $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.inputSuffix)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    style: (_vm.yesStyle),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v(_vm._s(_vm.noLabel))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    style: (_vm.noStyle),
    attrs: {
      "type": "button",
      "disabled": _vm.localValue < _vm.minVal
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.yesLabel))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89b984d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/input-number-modal.vue
// module id = 1044
// module chunks = 0